import { useEffect, useState } from 'react';
import { getPreviewConfig } from '@/utils/preview';

export function usePreviewData<T>(loaderData: T, refetch: () => Promise<T>): T {
  const [data, setData] = useState(loaderData);

  useEffect(() => {
    const preview = getPreviewConfig();

    if (!preview.active) {
      setData(loaderData);
      return () => {};
    }

    let cancelled = false;

    refetch()
      .then((nextData) => {
        if (!cancelled && nextData) {
          setData(nextData);
        }
      })
      .catch((error) => {
        console.error('Preview refetch failed:', error);
      });

    return () => {
      cancelled = true;
    };
  }, [loaderData, refetch]);

  return data;
}
